import { render, staticRenderFns } from "./salesman.vue?vue&type=template&id=3977ff22&scoped=true&"
import script from "./salesman.vue?vue&type=script&lang=js&"
export * from "./salesman.vue?vue&type=script&lang=js&"
import style0 from "./salesman.vue?vue&type=style&index=0&id=3977ff22&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3977ff22",
  null
  
)

export default component.exports